import { render, staticRenderFns } from "./UserRoleTable.vue?vue&type=template&id=aabb8286&"
import script from "./UserRoleTable.vue?vue&type=script&lang=js&"
export * from "./UserRoleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports